import React from 'react';

export default class InputText extends React.Component {
	render() {
		return <span className="input-text">{this.props.children}</span>;
	}
}
